import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _19be5254 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _2c3d54cf = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _2d7c6e5a = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _98fe325a = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _433ae944 = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _893ac552 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _424aff34 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _5b6acb98 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _bce9d612 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _bccda710 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _bc95490c = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _bc791a0a = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _531d5f90 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _4b482f0a = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _a14a8ec0 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _19be5254,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _2c3d54cf,
    children: [{
      path: "",
      component: _2d7c6e5a,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _98fe325a,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _433ae944,
      name: "have-a-card-success"
    }]
  }, {
    path: "/rejection",
    component: _893ac552,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _424aff34,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _5b6acb98,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _bce9d612,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _bccda710,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _bc95490c,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _bc791a0a,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _531d5f90,
    name: "errors-500"
  }, {
    path: "/patient/patientSearch",
    component: _4b482f0a,
    name: "patient-patientSearch"
  }, {
    path: "/",
    component: _a14a8ec0,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
